export type Preferences = Readonly<{
  showAllEventsInServicesTimeline: boolean
}>

export const defaultPreferences: Preferences = {
  showAllEventsInServicesTimeline: true,
}
